import { render, staticRenderFns } from "./info-system.vue?vue&type=template&id=49888525&scoped=true&"
import script from "./info-system.vue?vue&type=script&lang=js&"
export * from "./info-system.vue?vue&type=script&lang=js&"
import style0 from "./info-system.vue?vue&type=style&index=0&id=49888525&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49888525",
  null
  
)

export default component.exports